<template>
    <div class="aromat-benzol">
        <ul>
            <li>planar</li>
            <li>delokalisiertes Pi-Elektronen-System => Benzolring</li>
            <li>energiearm</li>
            <li>gleiche Bindungslänge/-winkel</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'aromat-benzol',
};
</script>
